module.exports = __webpack_public_path__ + "img/multi-package-white.301ef639.svg";